import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

import { outboundV2Service } from '@/services'
import { HouseBillScheduledSchema } from '@/services/OutboundV2Service'

interface OutboundState {
  loading: boolean
  printVisible: boolean
  houseBillsWithWarehouse: HouseBillScheduledSchema[]
  printingHouseBill: HouseBillScheduledSchema | null
}

interface OutboundActions {
  openLoading: () => void
  closeLoading: () => void
  openPrintDialog: () => void
  closePrintDialog: () => void
  fetchHouseBillsWithWarehouse: () => Promise<void>
  setPrintingHouseBill: (houseBill: HouseBillScheduledSchema) => void
  clearPrinting: () => void
  // outboundNext: (houseBillId: number) => void
}

type OutboundStore = OutboundState & OutboundActions

const initialState: OutboundState = {
  loading: false,
  printVisible: false,
  houseBillsWithWarehouse: [],
  printingHouseBill: null
}

export const useOutboundStore = create<OutboundStore>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        openLoading: () => set({ loading: true }),
        closeLoading: () => set({ loading: false }),
        openPrintDialog: () => set({ printVisible: true }),
        closePrintDialog: () => {
          get().clearPrinting()
          set({ printVisible: false })
        },
        fetchHouseBillsWithWarehouse: async () => {
          // const data = await houseBillService.getHouseBillsWithWarehouse()
          const { success, data } = await outboundV2Service.fetchScheduled()
          if (success) {
            set({
              houseBillsWithWarehouse: data
            })
          }
        },
        setPrintingHouseBill: (houseBill) =>
          set({
            printingHouseBill: houseBill
          }),
        clearPrinting: () =>
          set({
            printingHouseBill: null
          }),
        // outboundNext: async (houseBillId: number) => {
        //   // await houseBillService.outboundNext(houseBillId)
        //   await get().fetchHouseBillsWithWarehouse()
        // }
      }),
      {
        name: 'outbound-storage'
      }
    )
  )
)

export const useOutboundState = () => {
  const loading = useOutboundStore((state) => state.loading)
  const printVisible = useOutboundStore((state) => state.printVisible)
  const houseBillsWithWarehouse = useOutboundStore(
    (state) => state.houseBillsWithWarehouse
  )
  const printingHouseBill = useOutboundStore((state) => state.printingHouseBill)
  return { loading, printVisible, houseBillsWithWarehouse, printingHouseBill }
}

export const useOutboundActions = () => {
  const openLoading = useOutboundStore((state) => state.openLoading)
  const closeLoading = useOutboundStore((state) => state.closeLoading)
  const openPrintDialog = useOutboundStore((state) => state.openPrintDialog)
  const closePrintDialog = useOutboundStore((state) => state.closePrintDialog)
  const fetchHouseBillsWithWarehouse = useOutboundStore(
    (state) => state.fetchHouseBillsWithWarehouse
  )
  const setPrintingHouseBill = useOutboundStore(
    (state) => state.setPrintingHouseBill
  )
  const clearPrinting = useOutboundStore((state) => state.clearPrinting)
  // const outboundNext = useOutboundStore((state) => state.outboundNext)
  return {
    openLoading,
    closeLoading,
    openPrintDialog,
    closePrintDialog,
    fetchHouseBillsWithWarehouse,
    setPrintingHouseBill,
    clearPrinting,
    // outboundNext
  }
}
